import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse, APP_CONFIG, ModelRepository, RayModel } from '../core';
import { BaseService } from './base.service';
import { CaseService } from './case.service';


/**
* This service handles the ray analysis model.
*/
@Injectable({ providedIn: 'root' })
export class ModelService extends BaseService {

	private readonly config = inject(APP_CONFIG);
	private readonly caseSrv = inject(CaseService);
	private readonly modelRepo = inject(ModelRepository);

	private readonly _isReadOnly = toSignal(this.caseSrv.isReadOnly(), { initialValue: false });


	/**
	* Save current model.
	*/
	persistModel(caseId: string, userGuid: string): Observable<void> {
		if (!this._isReadOnly()) {
			const rayModel = this.rayModelMapper(caseId, userGuid);
			return this.modelRepo.saveModel(rayModel).pipe(map((res: ApiResponse<void>) => this.handleApiResponse(res)));
		}
		return of();
	}

	/**
	* Restore current model.
	*/
	restoreModel(caseId: string, userGuid: string): Observable<RayModel> {
		return this.modelRepo.getModel(caseId, userGuid).pipe(
			map((res: ApiResponse<RayModel>) => this.handleApiResponse(res))
		);
	}

	private readonly rayModelMapper = (caseId: string, userGuid: string): RayModel => {
		const model = (globalThis as any).main._saveHandler.getUpdatedData();
		return {
			version: this.config.rayModelVersion,
			caseId: caseId,
			userGuid: userGuid,
			model
		};
	}

}
